import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzLoadingText',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    text: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})